import { useEffect, useState } from 'react'
import { apiGet, apiPost } from '../utils/api'
import { useToasts } from './Toasts'

type User = { id: number; sub: string; email: string; name: string }
type Role = { role: { id: number; name: string }, permissions: { id: number; name: string }[] }

export default function RBACManage() {
  const tenantId = 1
  const { push } = useToasts()
  const [users, setUsers] = useState<User[]>([])
  const [roles, setRoles] = useState<Role[]>([])
  const [userId, setUserId] = useState<number>()
  const [roleId, setRoleId] = useState<number>()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string>()

  const load = async () => {
    setLoading(true)
    try {
      setUsers(await apiGet('/rbac/users'))
      setRoles(await apiGet('/rbac/roles'))
    } catch (e: any) { setError(e?.message || 'Load failed') }
    finally { setLoading(false) }
  }
  useEffect(() => { load() }, [])

  const assign = async () => {
    if (!userId || !roleId) { push({ text: 'Select user and role', kind: 'error' }); return }
    try {
      await apiPost('/rbac/assign', { user_id: userId, tenant_id: tenantId, role_id: roleId })
      push({ text: 'Role assigned', kind: 'success' })
    } catch (e: any) { push({ text: e?.message || 'Assign failed', kind: 'error' }) }
  }

  return (
    <div className="card">
      <h2 className="font-semibold mb-3">RBAC Management</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
        Gestisci ruoli e permessi per tenant. Seleziona un utente e un ruolo per assegnarlo al tenant attivo.
        I ruoli controllano le azioni disponibili (es. jobs.read, policies.write).
      </p>
      {loading ? <p>Loading…</p> : error ? <p className="text-red-600">{error}</p> : (
        <div className="flex gap-2 items-center">
          <select className="input" value={userId ?? ''} onChange={e => setUserId(Number(e.target.value))}>
            <option value="">Select user</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.name || u.email}</option>)}
          </select>
          <select className="input" value={roleId ?? ''} onChange={e => setRoleId(Number(e.target.value))}>
            <option value="">Select role</option>
            {roles.map(r => <option key={r.role.id} value={r.role.id}>{r.role.name}</option>)}
          </select>
          <button className="btn" onClick={assign}>Assign to tenant {tenantId}</button>
        </div>
      )}
    </div>
  )
}

